import React from 'react'
import { Spinner } from 'react-bootstrap';
import { Redirect, Route } from 'react-router';
import FirebaseConnect from '../../../Firebase/FirebaseConnect'

export default function PrivateRoute({children,...rest}) {
    const {user,isLoading} = FirebaseConnect();
    console.log(user);
    if(isLoading){
        
        return <Spinner variant='danger' animation='border'/>
    }
    return (
        <Route
        {...rest}
        render={({location})=>
            user.displayName?children:<Redirect
            to={{
                pathname:'/login',
                state:{from:location}
            }}>

            </Redirect>
        }
        >

        </Route>
    )
}
